import React from 'react';
import Navbar from '../../components/Navbar';
import { Shield, Lock, Eye, ChevronRight } from 'lucide-react';

const PrivacyPolicy = () => {
    return (
        <div className="bg-[#0b0e11] min-h-screen text-gray-100 font-sans selection:bg-blue-500/30">
            <Navbar />

            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
                <div className="text-center mb-16">
                    <h1 className="text-3xl sm:text-4xl font-bold text-white mb-4">Privacy Policy</h1>
                    <p className="text-gray-400 max-w-2xl mx-auto">
                        Your privacy is important to us. This policy explains how we collect, use, and protect your personal information.
                    </p>
                    <div className="mt-4 text-sm text-gray-500">
                        Last Updated: February 2026
                    </div>
                </div>

                <div className="bg-[#181a20] rounded-3xl p-8 sm:p-12 border border-gray-800 space-y-12">

                    <section>
                        <div className="flex items-center gap-3 mb-4">
                            <div className="bg-blue-500/10 p-2 rounded-lg text-blue-500">
                                <Eye size={24} />
                            </div>
                            <h2 className="text-xl font-bold text-white">Information We Collect</h2>
                        </div>
                        <div className="space-y-4 text-gray-400 leading-relaxed pl-14">
                            <p>
                                <strong>Personal Information:</strong> Includes your name, address, email address, phone number, date of birth, and proof of identity (such as passport or national ID).
                            </p>
                            <p>
                                <strong>Financial Information:</strong> Includes bank account details, transaction history, and wallet addresses.
                            </p>
                            <p>
                                <strong>Technical Information:</strong> Includes IP address, device type, operating system, and browser type.
                            </p>
                        </div>
                    </section>

                    <section>
                        <div className="flex items-center gap-3 mb-4">
                            <div className="bg-purple-500/10 p-2 rounded-lg text-purple-500">
                                <Shield size={24} />
                            </div>
                            <h2 className="text-xl font-bold text-white">How We Use Your Information</h2>
                        </div>
                        <div className="space-y-4 text-gray-400 leading-relaxed pl-14">
                            <ul className="list-disc space-y-2 ml-4">
                                <li>To provide and maintain our services.</li>
                                <li>To process your transactions securely.</li>
                                <li>To verify your identity in compliance with legal obligations.</li>
                                <li>To detect and prevent fraud and security breaches.</li>
                                <li>To communicate with you about updates, offers, and support.</li>
                            </ul>
                        </div>
                    </section>

                    <section>
                        <div className="flex items-center gap-3 mb-4">
                            <div className="bg-green-500/10 p-2 rounded-lg text-green-500">
                                <Lock size={24} />
                            </div>
                            <h2 className="text-xl font-bold text-white">Data Protection</h2>
                        </div>
                        <div className="space-y-4 text-gray-400 leading-relaxed pl-14">
                            <p>
                                We implement robust security measures to protect your personal information from unauthorized access, alteration, disclosure, or destruction. We use encryption, firewalls, and secure access controls.
                            </p>
                        </div>
                    </section>

                    <section>
                        <h2 className="text-xl font-bold text-white mb-4 ml-14">Sharing of Information</h2>
                        <div className="space-y-4 text-gray-400 leading-relaxed pl-14">
                            <p>
                                We do not sell your personal information. We may share your information with trusted third-party service providers who assist us in operating our platform, conducting our business, or serving our users, so long as those parties agree to keep this information confidential.
                            </p>
                        </div>
                    </section>

                    <section>
                        <h2 className="text-xl font-bold text-white mb-4 ml-14">Your Rights</h2>
                        <div className="space-y-4 text-gray-400 leading-relaxed pl-14">
                            <p>
                                You have the right to access, correct, or delete your personal information. You may also object to the processing of your data or request data portability. To exercise these rights, please contact our support team.
                            </p>
                        </div>
                    </section>

                </div>
            </div>
        </div>
    );
};

export default PrivacyPolicy;
